import React, { useEffect, useMemo, useState } from "react";
import * as image from "../../resources/images";
import { getCapitalized, getSequnceSort, textTrim } from "../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { getSctReflectionData, postBadgesCourse } from "../../redux/actions/APIs";
import { useLocation, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Line } from "rc-progress";
import ReactTooltip from "react-tooltip";
const SctStatus = ({activityData, currentSceneObj}) => {
    const params = useParams();
    const dispatch = useDispatch();
     const {
            defaultChildData,
            bagesCourseData,
        } = useSelector((state) => state.collections);
    useEffect(()=>{
        let body = params?.courseId ? [params?.courseId] : [];
        dispatch(postBadgesCourse(defaultChildData?.id, body))
    },[])
    return (
        <div className="myplan_listitems">
            <div className="LeftpanelContent sctleftpannel">
                <div className="sctframe">
                    <div className="sctconfeti flexone">
                        <span><img src={image.sct_confetti} alt="confeti" /></span>
                        <div className="confetimessage">
                            <h1 className="mb-2">Great Job {getCapitalized(defaultChildData?.firstName)}!</h1>
                            <p className="p1 lighttextcolor">You Completed This Module</p>
                        </div>
                        <span><img src={image.sct_confetti} alt="confeti" /></span>
                    </div>
                    <div className="sctgratimg">
                        <img src={image.Sct_communication}></img>
                    </div>
                </div>
                <div className="complection_status">
                    <h2 className="mb-4 ">Completion Status</h2>
                    <div className="module_obj_list flexone mb-4">
                        <div className="objcontent w-50">
                            <p class="p flextwo progess_navigation ">
                                <strong className=" mr-2"><i class="fa-regular fa-badge-check"></i></strong>
                               {activityData?.activityName}
                            </p>
                        </div>


                        <div className={`${activityData?.dimName}DimCard objpercentage w-40`}>
                            <p class="p3 textuppercase mb-1"><span class="mr-1">{activityData?.completion}%</span>Completion! 🎊🥳🤩️🎉<span class="ml-1">
                            </span></p>

                            <Line percent={activityData?.completion} strokeWidth={3} strokeColor="#85b812" />
                        </div>
                    </div>
                    <div className="module_obj_list flexone mb-4">
                        <div className="objcontent w-50">
                            <p class="p flextwo progess_navigation ">
                                <strong className=" mr-2"><i class="fa-regular fa-badge-check"></i></strong>
                                Performance
                            </p>
                        </div>


                        <div className={`${activityData?.dimName}DimCard objpercentage w-40`}>
                            <p class="p3 textuppercase mb-1"><span class="mr-1">{activityData?.proficiency}%</span><span class="ml-1">
                            </span></p>

                            <Line percent={activityData?.proficiency} strokeWidth={3} strokeColor="#85b812" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="yourachivement planprogress_list p-0">
                <div className="badgesdetails_card">
                    <h2 className="flexone mb-3 pb-3">Achievements Show Case 
                        {/* <span>
                        <span className="earned">Earned</span>{" "}
                            {bagesCourseData?.records?.length > 0 && bagesCourseData?.records[0]?.badges?.filter((item)=> !item?.isLock)?.length}/4
                            </span> */}
                        </h2>
                    {bagesCourseData?.records?.length > 0 && 
                        getSequnceSort(bagesCourseData?.records[0]?.badges)?.map((badge, index)=>(
                            activityData?.activityName == badge?.activityName && (
                            <div class="clbcarddtl pb-3  w-100"><div class="lbuserdtl flextwo w-100">
                                <div class="lbuserimage text-center">
                                    <img src={badge?.imageUrl ? badge?.imageUrl : "https://bloomster.s3.us-east-1.amazonaws.com/badge/Gale+Roc+%E2%80%93+The+Initiator.jpg"} alt="" />
                                </div>
                                <div class="lbuserName pb-2">
                                <h3 class="">{badge?.badgesName}</h3>
                                <p>{badge?.description}</p>
                                    <p class="m-0"></p>
                                <p></p>
                                </div>
                                {badge?.isLock ? (
                                    <div className="w-30 objcontent inprogress text-center">
                                        <i class="fa-regular fa-badge-check"></i> 
                                    </div>
                                ): (
                                    <div className="w-30 objcontent  text-center">
                                        <i class="fa-regular fa-badge-check"></i> 
                                    </div>
                                )}

                                  
                                </div>
                                </div>
                                )
                    ))}
                </div>
            </div>
        </div>
    )
}
export default SctStatus;